import {v4 as uuid} from 'uuid'



export const getHeaders = ()=>{
    return (["ID", "Originator", "Sale ID", "Time"])
}

export const getList = ()=>{
    return([
        {
            id: uuid(),
            originator: "Kevin Sampong",
            saleId: uuid(),
            time: "12 March 2021, 12:30pm"
        }
    ])
}